import type { CoreInsuranceResponseList, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Get all booking insurances by ID.
 *
 * @endpoint GET /api/saas/me/bookings/{bookingId}/insurances
 * @scope saas
 * @see https://flecto.dev/api-4724219
 */
export async function getAllBookingInsurances(
  bookingId: ParameterID
): Promise<CoreInsuranceResponseList> {
  const [resBookingInsurances] = await Promise.all([
    api.get(`/api/saas/me/bookings/${bookingId}/insurances`),
  ])

  return resBookingInsurances.data
}
